/**
 * Typewriter-tekst (De Gids / baas-monoloog). Klik versnelt: eerst de tekst
 * compleet maken, daarna `onKlaar`. Respecteert prefers-reduced-motion (toont
 * dan direct volledig).
 */
import { useEffect, useRef, useState } from 'react';

interface Props {
  tekst: string;
  kleur?: string;
  klaarLabel?: string;
  onKlaar?: () => void;
}

const reducedMotion = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export function GidsTekst({ tekst, kleur = '#c9a86a', klaarLabel, onKlaar }: Props) {
  const [aantal, setAantal] = useState(reducedMotion ? tekst.length : 0);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);
  const compleet = aantal >= tekst.length;

  useEffect(() => {
    setAantal(reducedMotion ? tekst.length : 0);
  }, [tekst]);

  useEffect(() => {
    if (reducedMotion || compleet) return;
    timer.current = setInterval(() => {
      setAantal((n) => {
        if (n >= tekst.length) { if (timer.current) clearInterval(timer.current); return n; }
        return n + 1;
      });
    }, 18);
    return () => { if (timer.current) clearInterval(timer.current); };
  }, [tekst, compleet]);

  const klik = () => {
    if (!compleet) setAantal(tekst.length);
    else onKlaar?.();
  };

  return (
    <button type="button" onClick={klik} className="group flex max-w-2xl flex-col items-center gap-4 text-center">
      <p className="text-lg leading-relaxed text-slate-200" style={{ fontFamily: 'EB Garamond, serif' }}>
        {tekst.slice(0, aantal)}
        {!compleet && <span className="animate-pulse" style={{ color: kleur }}>▌</span>}
      </p>
      {compleet && onKlaar && (
        <span className="rounded-full border px-4 py-1.5 text-sm transition group-hover:brightness-125" style={{ borderColor: kleur, color: kleur }}>
          {klaarLabel ?? 'Verder'} →
        </span>
      )}
    </button>
  );
}
